'use strict';

const h = require('phy');
const EnrollmentIframe = require('./enrollment_iframe');

const EnrollmentModal = ({ closeModalText }) => {
  const closeIcon = h(
    'div.close-modal-container',
    h('a.close-modal.icon-x.close', closeModalText)
  );

  const loadingSpinner = '.gig-spinner.gig-spinner-brnd';

  return h(
    'div.modal#select-widget-enrollment-modal',
    {
      role: 'dialog',
      'data-bhw': 'SelectEnrollmentModal',
      'data-bh-viewport': 'respect',
      'data-closeonbgclick': 'false',
    },
    h(
      'div',
      closeIcon,
      h(
        'div.modal-body.fx-row',
        h('div.columns#enrollment-modal-benefits'),
        h(
          `div.columns${loadingSpinner}#enrollment-modal-iframe-column`,
          h(EnrollmentIframe)
        )
      )
    )
  );
};

module.exports = EnrollmentModal;
